import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function TranslateHttpLoaderFactory(httpClient: HttpClient, module = 'translations') {
    return new TranslateHttpLoader(httpClient, './assets/i18n/', `/${module}.json`);
}
